import React from 'react';
import PropTypes from 'prop-types';
import { StateLabel } from '@common/components';

const COLOR_STYLE_MAP = {
  onboarding: 'harvest-gold',
  cleared: 'grass-lighter',
  working: 'grass',
  completed: 'grass-darkest',
};

export const LABEL_OVERWRITE = {
  onboarding: 'Onboarding',
  cleared: 'Cleared',
  working: 'Working',
  completed: 'Completed',
};

export function StaffingRequestAssignmentState({ state }) {
  return (
    <StateLabel
      state={LABEL_OVERWRITE[state] || state}
      color={COLOR_STYLE_MAP[state]}
    />
  );
}

StaffingRequestAssignmentState.propTypes = {
  state: PropTypes.string.isRequired,
};
